import Vue from 'vue'
import BatchOfflineCollectDialog from './index.vue'

/**
 * 命令式打开【批量线下收款】扫码支付弹窗（MessageBox 风格）
 * @param {Object} params 可选参数，透传到组件的 showDialog(openParams)
 * @returns {Promise<'confirm'>} Promise，在用户点击“已扫码支付，返回”时 resolve('confirm')，关闭时 reject('closed')
 */
export function openBatchOfflineCollectDialog(params = {}) {
  const container = document.createElement('div')
  document.body.appendChild(container)

  let app = null
  let instance = null

  return new Promise((resolve, reject) => {
    const handleConfirm = () => {
      resolve('confirm')
      // 组件会自行关闭，这里做清理
      cleanup()
    }

    const handleClosed = () => {
      // 用户直接关闭弹窗（或通过代码关闭）
      reject('closed')
      cleanup()
    }

    const cleanup = () => {
      if (app) {
        app.$destroy()
      }
      if (container && container.parentNode) {
        container.parentNode.removeChild(container)
      }
      app = null
      instance = null
    }

    app = new Vue({
      render(h) {
        return h(BatchOfflineCollectDialog, {
          ref: 'comp',
          on: {
            confirm: handleConfirm,
            closed: handleClosed,
          },
        })
      },
    }).$mount(container)

    instance = app.$refs.comp

    Vue.nextTick(() => {
      if (instance && typeof instance.showDialog === 'function') {
        instance.showDialog(params)
      }
    })
  })
}

export default {
  open: openBatchOfflineCollectDialog,
}
